import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { POST_MESSAGE_TYPES, IFRAME_ID } from "./constants";
var GUESTY_TOKENIZATION_FORM_READY = POST_MESSAGE_TYPES.GUESTY_TOKENIZATION_FORM_READY,
  GUESTY_TOKENIZATION_FORM_RESIZE = POST_MESSAGE_TYPES.GUESTY_TOKENIZATION_FORM_RESIZE,
  GUESTY_TOKENIZATION_FORM_STATUS_CHANGE = POST_MESSAGE_TYPES.GUESTY_TOKENIZATION_FORM_STATUS_CHANGE,
  GUESTY_TOKENIZATION_FORM_SUBMIT = POST_MESSAGE_TYPES.GUESTY_TOKENIZATION_FORM_SUBMIT,
  GUESTY_TOKENIZATION_FORM_VALIDATE = POST_MESSAGE_TYPES.GUESTY_TOKENIZATION_FORM_VALIDATE,
  GUESTY_TOKENIZATION_ERROR = POST_MESSAGE_TYPES.GUESTY_TOKENIZATION_ERROR,
  GUESTY_TOKENIZATION_SUCCESS = POST_MESSAGE_TYPES.GUESTY_TOKENIZATION_SUCCESS,
  GUESTY_TOKENIZATION_FORM_PROPS = POST_MESSAGE_TYPES.GUESTY_TOKENIZATION_FORM_PROPS;
export var getOrigin = function getOrigin(env) {
  var envSuffix = env === 'production' ? '' : "-".concat(env);
  return "https://pay".concat(envSuffix, ".guesty.com");
};
export var getIFrame = function getIFrame(id) {
  var iframe = document.getElementById(id);
  if (!iframe) throw new Error('Guesty Tokenization iframe is not found, please call guestyTokenization.render() first');
  return iframe;
};
export var resizeIFrame = function resizeIFrame(_ref) {
  var iframe = _ref.iframe,
    height = _ref.height;
  iframe.style.height = "".concat(height, "px");
};
export var postMessage = function postMessage(_ref2) {
  var iframe = _ref2.iframe,
    origin = _ref2.origin,
    message = _ref2.message;
  iframe.contentWindow.postMessage(message, origin);
};
var initialize = function initialize() {
  var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'production';
  var origin = getOrigin(env);
  var messageHandler;
  var render = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref4,
        containerId,
        providerId,
        onStatusChange,
        lang,
        apiVersion,
        currency,
        amount,
        skip3DS,
        styles,
        showInitialValuesToggle,
        initialValuesToggleLabel,
        initialValues,
        sections,
        sectionsConfig,
        showSupportedCards,
        showPciCompliantLink,
        _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref4 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, containerId = _ref4.containerId, providerId = _ref4.providerId, onStatusChange = _ref4.onStatusChange, lang = _ref4.lang, apiVersion = _ref4.apiVersion, currency = _ref4.currency, amount = _ref4.amount, skip3DS = _ref4.skip3DS, styles = _ref4.styles, showInitialValuesToggle = _ref4.showInitialValuesToggle, initialValuesToggleLabel = _ref4.initialValuesToggleLabel, initialValues = _ref4.initialValues, sections = _ref4.sections, sectionsConfig = _ref4.sectionsConfig, showSupportedCards = _ref4.showSupportedCards, showPciCompliantLink = _ref4.showPciCompliantLink;
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              if (apiVersion && !['v1', 'v2'].includes(apiVersion)) {
                reject(new Error('Invalid apiVersion'));
                return;
              }
              if (!containerId) {
                reject(new Error('containerId is required'));
                return;
              }
              var container = document.getElementById(containerId);
              if (!container) {
                reject(new Error("Container with id '".concat(containerId, "' is not found")));
                return;
              }
              if (!providerId) {
                reject(new Error('providerId is required'));
                return;
              }
              if (!/^[0-9a-fA-F]{24}$/.test(providerId)) {
                reject(new Error('providerId is invalid'));
                return;
              }
              if (!skip3DS && typeof amount !== 'number') {
                reject(new Error('amount must be a valid number'));
                return;
              }
              if (!skip3DS && typeof currency !== 'string') {
                reject(new Error('currency must be a valid string'));
                return;
              }
              if (onStatusChange && typeof onStatusChange !== 'function') {
                reject(new Error('onStatusChange must be a function'));
                return;
              }
              messageHandler = function messageHandler(e) {
                if (e.origin !== origin) return;
                var type = e.data.type;
                if (type === GUESTY_TOKENIZATION_FORM_RESIZE) {
                  var height = e.data.height;
                  var _iframe = getIFrame(IFRAME_ID);
                  resizeIFrame({
                    iframe: _iframe,
                    height: height
                  });
                }
                if (type === GUESTY_TOKENIZATION_FORM_STATUS_CHANGE && onStatusChange) {
                  onStatusChange(e.data.isValid);
                }
                if (type === GUESTY_TOKENIZATION_FORM_READY) {
                  var _iframe2 = getIFrame(IFRAME_ID);
                  postMessage({
                    iframe: _iframe2,
                    origin: origin,
                    message: {
                      type: GUESTY_TOKENIZATION_FORM_PROPS,
                      payload: {
                        styles: styles,
                        showInitialValuesToggle: showInitialValuesToggle,
                        initialValuesToggleLabel: initialValuesToggleLabel,
                        initialValues: initialValues,
                        sections: sections,
                        sectionsConfig: sectionsConfig,
                        showSupportedCards: showSupportedCards,
                        showPciCompliantLink: showPciCompliantLink,
                        amount: amount,
                        currency: currency,
                        skip3DS: skip3DS
                      }
                    }
                  });
                  resolve();
                }
              };
              window.addEventListener('message', messageHandler, false);
              var searchParams = new URLSearchParams(_extends({
                providerId: providerId,
                version: 'v1'
              }, apiVersion && {
                apiVersion: apiVersion
              }));
              if (lang) {
                searchParams.set('lang', lang);
              }
              var queryString = searchParams.toString();
              var iframe = document.createElement('iframe');
              iframe.src = "".concat(origin, "?").concat(queryString);
              iframe.style.border = 'none';
              iframe.style.width = '100%';
              iframe.id = IFRAME_ID;
              iframe.onerror = reject;
              container.appendChild(iframe);
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function render() {
      return _ref3.apply(this, arguments);
    };
  }();
  var validate = function validate() {
    var iframe = getIFrame(IFRAME_ID);
    postMessage({
      iframe: iframe,
      origin: origin,
      message: {
        type: GUESTY_TOKENIZATION_FORM_VALIDATE
      }
    });
  };
  var submit = function submit() {
    return new Promise(function (resolve, reject) {
      var handleTokenizationResult = function handleTokenizationResult(e) {
        if (e.origin !== origin) return;
        var type = e.data.type;
        if (type === GUESTY_TOKENIZATION_SUCCESS) {
          window.removeEventListener('message', handleTokenizationResult);
          resolve(e.data.token);
        }
        if (type === GUESTY_TOKENIZATION_ERROR) {
          window.removeEventListener('message', handleTokenizationResult);
          reject(e.data.error);
        }
      };
      window.addEventListener('message', handleTokenizationResult, false);
      var iframe = getIFrame(IFRAME_ID);
      postMessage({
        iframe: iframe,
        origin: origin,
        message: {
          type: GUESTY_TOKENIZATION_FORM_SUBMIT
        }
      });
    });
  };
  var destroy = function destroy() {
    var iframe = getIFrame(IFRAME_ID);
    iframe.remove();
    window.removeEventListener('message', messageHandler);
  };
  return {
    render: render,
    submit: submit,
    validate: validate,
    destroy: destroy
  };
};
export default initialize;